/**
 * Load CrazyEgg functions
 */

(function (pmw, $, undefined) {

	pmw.loadCrazyeggPixel = function () {

		try {
			// CrazyEgg script URL format: //script.crazyegg.com/pages/scripts/XXXX/YYYY.js
			// Where XXXXYYYY is the 8-digit account number
			const accountNumber = pmwDataLayer.pixels.crazyegg.account_number;
			const firstPart     = accountNumber.substring(0, 4);
			const secondPart    = accountNumber.substring(4, 8);

			const script  = document.createElement('script');
			script.type   = 'text/javascript';
			script.async  = true;
			script.src    = '//script.crazyegg.com/pages/scripts/' + firstPart + '/' + secondPart + '.js';

			const firstScript = document.getElementsByTagName('script')[0];
			firstScript.parentNode.insertBefore(script, firstScript);

			pmwDataLayer.pixels.crazyegg.loaded = true;

			pmw.console.log('CrazyEgg: pixel loaded');

		} catch (e) {
			console.error(e)
		}
	}

}(window.pmw = window.pmw || {}, jQuery));
